<template>
	<div class="text">
		<p>欢迎使用芝麻招工实名认证及企业认证服务协议（以下称“本服务”），芝麻招工实名认证及企业认证授权服务协议（以下称“本协议”）为上海博夫教育科技有限公司（以下称“我们”）与用户（以下称“您”）签订的授权协议。在接受本协议之前，请仔细阅读本协议的全部内容。【特别提示】请您仔细阅读我们提供的《芝麻招工实名认证及企业认证服务协议》
		</p>
		<p class="head">一、定义</p>
		<p>芝麻招工：指芝麻招工客户端，以及芝麻招工微信小程序。</p>
		<p class="head">二、功能说明</p>
		<p>为保障用户账户的安全，提供更好的服务，芝麻招工在提供部分产品及服务之前，采用身份证件验证识别和验证功能对用户的身份进行验证，用于验证操作人是否为账户持有者本人，通过实名识别结果评估是否为用户提供产品或服务，以及采用营业执照证件验证识别和验证功能对企业的身份进行验证，用于验证是否为企业授权操作，通过企业认证识别结果评估是否为用户提供企业服务。该功能由阿里云提供核验数据及技术支持。
		</p>
		<p class="head">三、授权与许可</p>
		<p>如您点击“我已阅读并同意”或以其他方式选择接受本协议规则，则视为您在使用身份验证识别及企业验证识别服务时，同意并授权芝麻招工及其合作的认证服务机构获取、使用您在申请芝麻招工服务过程中所提供的个人信息（包括姓名、身份证号）及企业信息（包括公司名称、社会统一组织机构码）数据，并提供给合法存有您信息的第三方合作机构进行比对核验，以核验您的身份及企业身份。特别提示您知悉，芝麻招工使用的是阿里云计算有限公司提供的认证服务。如您不同意本协议的任何内容，或者无法准确理解协议内容的解释，请不要进行后续操作。
		</p>
		<p class="head">四、信息安全声明</p>
		<p>芝麻招工承诺对您的个人信息严格保密，并基于国家监管部门认可的加密算法进行数据加密传输，数据加密存储。如因不可抗力、计算机黑客袭击、系统故障、通讯故障、电脑病毒、恶意程序攻击及其他不可归因于芝麻招工的情况而导致用户损失的，芝麻招工不承担任何责任。芝麻招工与合作机构签订保密合同，并要求合作伙伴做好用户信息安全保障，承诺尽到信息安全保护义务。
		</p>
	</div>
</template>

<script>
	export default {
		beforeCreate() {
			document.title = '《芝麻招工实名认证及企业认证服务协议》'
		}
	}
</script>

<style>
	.text {
		padding: 15px;
		font-size: 14px;
		color: #333;
	}

	.text p {
		line-height: 1.6;
	}

	.text .head {
		font-weight: 500;
	}

	.text .space2 {
		text-indent: 2em;
	}

	.text .space4 {
		text-indent: 4em;
	}
</style>
